import { render } from "./ClaimNotes.vue?vue&type=template&id=282de970&scoped=true"
import script from "./ClaimNotes.vue?vue&type=script&lang=js"
export * from "./ClaimNotes.vue?vue&type=script&lang=js"

import "./ClaimNotes.vue?vue&type=style&index=0&id=282de970&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282de970"]])

export default __exports__